import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 10: Today's Korea</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 10: 오늘의 한국</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

{/* INTRO */}
이승만 — Lee Seung Man, the first president of South Korea (pictured below) <br></br>
<img className="epPic-sm" src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Rhee_Syng-Man_in_1948.jpg/200px-Rhee_Syng-Man_in_1948.jpg"></img><br></br>
<br></br>
박정희 — Park Jung Hee, the third president of South Korea (pictured below) <br></br>
<img className="epPic-sm" src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Park_Chung-hee.jpg/250px-Park_Chung-hee.jpg"></img><br></br>
<br></br>
전두환 — Jun Do Hwan, the fifth president of South Korea (pictured below) <br></br>
<img className="epPic-sm" src="https://mblogthumb-phinf.pstatic.net/20101217_55/jiaptng_1292557825464mhlew_JPEG/f0087482_4bb4b1e5e5673.jpg?type=w420"></img><br></br>
<br></br>
인권 (in gwun) — human rights <br></br>
요구하다 (yo guh ha da) — to request, call for <br></br>
시위 (she wee) — protest  <br></br>
광주 시민 (gwang ju she min) — citizens of Gwang Ju <br></br>
죽였다 (jook yut da) — killed <br></br>
6월 민주항쟁 — June Democracy movement (pictures below) <br></br>
<br></br>
<img className="epPic-m" src="https://mblogthumb-phinf.pstatic.net/MjAxODA2MDhfMjI1/MDAxNTI4NDM0MjI2NTk3.JBAAIdGPa6FCm9HM2GtPX7WwtSoJkRrOEMIjnjeK2Mkg.tHO_jnMxCcno38vqAzuRMdO_KSCFBuEBKMCcQAXkdCQg.JPEG.primeministerkr/610민주항쟁1.jpg?type=w800"></img><br></br>
<img className="epPic-m" src="https://www.seohaenews.net/data/photos/20200624/art_1591756433949_0dbd3d.jpg"></img><br></br>
<br></br>
오늘 (oh neul) — today <br></br>

<br></br>
{/* NEW PRESIDENT */}
다음 (dah eum) — next <br></br>
대통령 (dae tong ryeong) — president <br></br>
선정하다 (sun jeong ha da) — to choose <br></br>
선거 (sun guh) — election <br></br>
임명하다 (im myeong ha da) — to appoint <br></br>
민주주의 (min juh juh eeh) — democracy <br></br>
6월 10일 (yook woul ship il) —June 10th <br></br>
6월 29일 (yook woul eeh ship goo il) — June 29th <br></br>

<br></br>
{/* OLYMPICS */}
다음 년 (da eum nyeon) — next year <br></br>
서울 (seo ul) — Seoul, the capital of Korea <br></br>
외국인 (wae guk in) — foreigner <br></br>
오다 (oh da) — to come <br></br>
관람하다 (gwan ram ha da) — to watch <br></br>

선거 (seon guh) — election <br></br>
이길 수 있다 (eeh gil soo it da) — to be able to win <br></br>
믿다 (mit da) — to believe <br></br>
조작되다 (jo jak dwae da) — to be rigged <br></br>
정당하게 (jung dan hah gae) — fairly <br></br>
당선되다 (dang sun dwae da) — to be elected <br></br>

<br></br>
{/* CURRENTLY */}
박근혜 — Park Geun Hye, the first female president of South Korea (pictured below)<br></br>
<img className="epPic-sm" src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Park_Geun-hye_presidential_portrait.png/250px-Park_Geun-hye_presidential_portrait.png"></img><br></br>
<br></br>
탄핵하다 (tan haek ha da) — to impeach <br></br>
난리가 나다 (nan ri ga na da) — it was chaotic/there was an uproar <br></br>
문재인 (moon jae in) — the current president of South Korea, as of 2021 (pictured below) <br></br>
<img className="epPic-sm" src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Moon_Jae-in_presidential_portrait.jpg/250px-Moon_Jae-in_presidential_portrait.jpg"></img><br></br>
<br></br>




                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;